import { getElementByName } from 'utilitys/helpers/general';

import { IPortfolioTopHeroesComponentsList } from 'api/queries/getProjectScoreCardsSummary';

export const serializeoverAllStatusData = ({
    data,
}: {
    data?: IPortfolioTopHeroesComponentsList;
}): IPortfolioTopHeroesComponentsList | null => {
    return data
        ? Object.keys(data)
              .sort()
              .reduce((scoreBoardAccumulator, key) => {
                  scoreBoardAccumulator[key] = data[key];
                  return scoreBoardAccumulator;
              }, {} as IPortfolioTopHeroesComponentsList)
        : null;
};

export const getCardItemValue = (data) => {
    return !Array.isArray(data) ? data : getElementByName(data, 'count').value;
};
